
<template>
  <div>
    <b-modal v-model="modal" scrollable hide-header infomodal hide-footer class="p-1 mt-4" dialog-class="info-modal">
      <div class="row">
        <div class="col-12 px-3 text-right">
          <button class="btn btn-md mb-0 p-0" @click="closeModal()"><h3>×</h3></button>
        </div>
        <div class="col-12 ">
          <p class="text-center mt-0 mb-0 px-0 blue-title"><b>{{title}}</b></p>
        </div>
      </div>
        <div class="row mt-4">
          <div class="col-11 mx-auto text-center">
            <p class="des">{{ desciption }}</p>
          </div>
        </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modal: false,
      title: "",
      desciption: "",
    }

  },
  methods: {
    closeModal(){
      this.modal = false
    },
    showModal(title, desciption){
      this.modal = true
      this.title = title
      this.desciption = desciption
    },
  },
}
</script>
<style scoped lang="scss">
.blue-title{
  color: #006fd2
}

.btn{
  padding: .235rem .75rem;
}
.des {
  text-align: justify;
  text-justify: inter-ideograph;
}
</style>
